import { atom } from "recoil";
import { IRecipientTag } from "../types/SavedSearchTypes";
import { ITagQuery } from "../types/TagQueryTypes";
import { ITag } from "../types/TagTypes";

export interface ContactFilter {
  withoutTag: ITag[];
  withTags: ITag[];
  allOfTags: ITag[];
  savedSearchName?: string;
  tagQuery: ITagQuery;
  recipientTags: IRecipientTag[];
}

export const ContactFilterAtom = atom<ContactFilter | null>({
  key: "ContactFilter",
  default: null,
});

export const IsCheckedAllContactsAtom = atom<boolean>({
  key: "IsCheckedAllContacts",
  default: false,
});

export const IsCheckedAllContactsOnCampaignAtom = atom<boolean>({
  key: "IsCheckedAllContactsOnCampaignAtom",
  default: false,
});

export const AllContactsTotalAtom = atom<number>({
  key: "AllContactsTotal",
  default: 0,
});

export const IsDefaultStatusAtom = atom<boolean>({
  key: "IsDefaultStatusAtom",
  default: true,
});
